'use client'

import React from 'react'
import { PaymentMethod } from '@dustin-web/microsite-config'
import { PaymentMethodsImages } from '@dustin-web/microsite-components/src/payment-methods-images'
import { useUserSettings } from '@dustin-web/microsite-components/src/hooks'

const paymentMethodsDefinitions = [
  {
    type: PaymentMethod.KLARNA,
    width: 64,
    height: 28,
  },
  {
    type: PaymentMethod.MASTERCARD,
    width: 45,
    height: 32,
  },
  {
    type: PaymentMethod.VISA,
    width: 62,
    height: 20,
  },
  {
    type: PaymentMethod.TRUSTLY,
    width: 65,
    height: 28,
  },
  {
    type: PaymentMethod.SWISH,
    width: 71,
    height: 22,
  },
  {
    type: PaymentMethod.VISADK,
    width: 42,
    height: 28,
  },
  {
    type: PaymentMethod.IDEAL,
    width: 30,
    height: 30,
  },
  {
    type: PaymentMethod.PAYTRAIL,
    width: 34,
    height: 34,
  },
  {
    type: PaymentMethod.MOBILEPLAY,
    width: 68,
    height: 24,
  },
  {
    type: PaymentMethod.INVOICE,
    width: 66,
    height: 16,
  },
] as const

type Props = {
  paymentMethods: PaymentMethod[]
}

export const PaymentMethodsContainer = ({ paymentMethods }: Props) => {
  const { twoLetterISOLanguageName } = useUserSettings()

  const paymentMethodsToShow = paymentMethodsDefinitions.filter(definition =>
    paymentMethods.includes(definition.type)
  )

  return paymentMethods ? (
    <div className="d-flex flex-wrap flex-row align-items-center gap-24 u-mb-24">
      <PaymentMethodsImages
        onBackground="dark"
        language={twoLetterISOLanguageName}
        paymentMethods={paymentMethodsToShow}
      />
    </div>
  ) : null
}
